import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var PatchIcon = function (_a) {
    var icon = _a.icon;
    return _jsx(FontAwesomeIcon, { size: icon.extId ? 'sm' : '1x', icon: icon });
};
export default PatchIcon;
